import { useNavigate } from "react-router-dom";
export function EmptyDashboardComponent({ icon: Icon }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        {Icon && <Icon className="w-8 h-8 text-gray-400" />}
      </div>
      <h3 className="font-medium text-gray-900 mb-2">No upcoming meals</h3>
      <p className="text-sm text-gray-600 text-center mb-6 max-w-sm">
        Start planning your week! Add meals to your calendar to see them here.
      </p>
      <button
        onClick={() => navigate("/meal-plans")}
        className="px-4 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
      >
        Plan Meals
      </button>
    </div>
  );
}
